// lib
import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';

import PhoneNumber from '@joinforma/ui/components/PhoneNumber';

// src
import TextField from '@joinforma/ui/components/TextField';
import { FieldValidator } from 'final-form';
import { composeTextFieldValidators } from 'utils/validate';

const TextFieldStyled = styled(TextField)`
  width: 288px;
  margin-bottom: 24px;
`;

const PhoneFieldStyled = styled(PhoneNumber)`
  width: 288px;
  margin-bottom: 24px;
`;

type RenderTextFieldProps<T = string> = {
  name: string;
  label: string;
  is_phone?: boolean;
  /**
   * Provide optional array of validators for specific TextField.
   *
   * Example: validators=[required, isEmail, isGovernmentEmailAddress]
   */
  validators?: FieldValidator<T>[];
};

export const RenderTextField = <T extends string | undefined>({
  name,
  label,
  is_phone = false,
  validators,
}: RenderTextFieldProps<T>) => {
  const composedValidators = validators
    ? composeTextFieldValidators(...validators)
    : undefined;

  if (is_phone) {
    return (
      <Field
        name={name}
        render={({ input, meta }) => (
          <PhoneFieldStyled
            {...input}
            label={label}
            placeholder={'Phone Number'}
            error={meta.modified && meta.error}
          />
        )}
        validate={composedValidators}
      />
    );
  }

  return (
    <Field
      name={name}
      render={({ input, meta }) => (
        <TextFieldStyled
          {...input}
          label={label}
          error={meta.touched && meta.error}
        />
      )}
      validate={composedValidators}
    />
  );
};
